export function areThereDuplicationInArray<T>(arr: T[]): boolean {
  return arr.length !== [...new Set(arr)].length;
}
